export const nullComponentDefault = () => null;
